import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "main-page" }
const _hoisted_2 = {
  key: 0,
  class: "succes"
}
const _hoisted_3 = { key: 0 }
const _hoisted_4 = {
  key: 1,
  class: "alert"
}
const _hoisted_5 = { key: 0 }
const _hoisted_6 = {
  key: 2,
  class: "error"
}
const _hoisted_7 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.type == 'succes')
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _cache[0] || (_cache[0] = _createElementVNode("img", {
            src: "https://aeroguestblobstorageprod.blob.core.windows.net/icons23/Info/1.5/check.svg",
            class: "succes-filter"
          }, null, -1)),
          (!!_ctx.text)
            ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(_ctx.text), 1))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (_ctx.type == 'alert')
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _cache[1] || (_cache[1] = _createElementVNode("img", {
            src: "https://aeroguestblobstorageprod.blob.core.windows.net/icons23/Info/1.5/exclamation_mark.svg",
            class: "alert-filter"
          }, null, -1)),
          (!!_ctx.text)
            ? (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(_ctx.text), 1))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (_ctx.type == 'error')
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _cache[2] || (_cache[2] = _createElementVNode("img", {
            src: "https://aeroguestblobstorageprod.blob.core.windows.net/icons23/Info/1.5/cross.svg",
            class: "error-filter"
          }, null, -1)),
          (!!_ctx.text)
            ? (_openBlock(), _createElementBlock("p", _hoisted_7, _toDisplayString(_ctx.text), 1))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ]))
}